<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-modal title="Règles du jeu" size="lg" hide-footer centered v-model="modalSwitch" id="my-modal">
    <div class="row">
      <div class="col-md-4">
        <img
          src="https://cdn.exploreve.fr/content/personnages/leon.svg"
          height="400px"
          style="position: relative; left: 50px;"
        />
      </div>

      <div class="col-md-8">
        <div style="font-family: 'faune'; font-weight: bold; font-size: 15px; margin-right: 20px;">
          Bienvenue au Jamboree de Moisson ! C’est ici qu’en 1947, 24 000 scouts se sont rassemblés pour le Jamboree
          mondial de la Paix, avec des participants de plus de 70 pays !
        </div>
        <div style="font-family: 'faune'; margin-top: 15px; font-size: 13px;">
          Pour récupérer les objets qui aideront Léon à réparer le ballon tu vas devoir aller à la rencontre des
          différents participants et lieux du Jamboree. Certains devraient avoir de quoi t’aider. Pour cela, tu peux te
          ballade sur la carte avec ta souris ou les flèches de ton clavier. Clique sur un personnage pour parler avec
          lui. Tiens toi prêt, ils auront surement des défis à te proposer !
        </div>
        <div class="row">
          <div class="col-md-3">
            <img
              src="https://cdn.exploreve.fr/content/sac_a_dos/sac_a_dos.svg"
              alt=""
              style="position: relative; left: 10px; top: 20px;"
            />
          </div>
          <div class="col-md-9">
            <div style="font-family: 'faune'; margin-top: 15px; font-size: 13px;">
              Pour consulter la liste des objets que tu as déjà récupérés et ceux que tu dois encore trouver, n’hésite
              pas à cliquer sur ton sac à dos, en bas à gauche de ton écran ! Tu y trouveras aussi ton précieux codex
              avec de nouvelles informations à l’intérieur !
            </div>
            <div @click="close" class="object">
              Commencer les recherches !
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<style>
.container-object {
  padding: 30px;
  display: block;
}
.row-objects {
  border-top: 2px solid black;
  height: 40px;
  align-content: center;
}
</style>
<script>
export default {
  props: {
    currentModal: Object,
    open: Boolean,
    objects: Array
  },
  data: function () {
    return {
      modalSwitch: false
    };
  },
  watch: {
    open: function () {
      this.modalSwitch = true;
    }
  },
  methods: {
    close() {
      this.modalSwitch = false;
    }
  }
};
</script>
